import Link from 'next/link'
import { Join } from '../../lib/utils'

interface HeroNoteLinkProps {
  title?: string
  href: string
  children: React.ReactNode
  classNames?: string
  classes?: string
  highlightClasses?: string
  ariaDescribedby?: string
}

export function HeroNoteLink({
  title,
  href,
  children,
  classNames = '',
  classes = '',
  highlightClasses = 'bg-blue-900/50',
  ariaDescribedby = '',
}: HeroNoteLinkProps) {
  return (
    <Link
      href={href}
      aria-describedby={ariaDescribedby}
      className={Join(
        'group font-xs relative flex max-w-max rounded-full bg-blue-500/40 font-bold text-white/80 transition dark:bg-blue-500/30',
        classNames,
      )}
      title={title}
    >
      <div className="ease-in-out-cubic absolute z-0 h-full w-[66px] rounded-l-full rounded-r-none bg-blue-600/60 transition-all duration-150 group-hover:w-full group-hover:rounded-r-full group-hover:bg-blue-600/60" />
      <span className="relative flex">
        <span
          className={Join(
            'w-[65px] rounded-l-full py-1 pr-3 pl-4',
            highlightClasses,
          )}
        >
          NEW
        </span>
        <span
          className={Join(
            'font-inter rounded-r-full py-1 pr-6 pl-4 font-normal',
            classes,
          )}
        >
          {children}
        </span>
      </span>
    </Link>
  )
}
